import { useQuery } from '@tanstack/react-query';
import { diary } from '@/utils/api';

export function useDiaryEntries(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['diary', params],
    queryFn: () => diary.getAll(params).then((r) => r.data),
  });
}

export function useDiaryProjects() {
  return useQuery({
    queryKey: ['diary', 'projects'],
    queryFn: () => diary.getProjects().then((r) => r.data),
  });
}

export function useDiaryWeek(projectId: number | string | undefined, year: number, week: number) {
  return useQuery({
    queryKey: ['diary', 'week', projectId, year, week],
    queryFn: () => diary.getWeek(projectId, year, week).then((r) => r.data),
    enabled: !!projectId,
  });
}
